<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
>
  <div class="icon-text">
    <span class="icon-circle" [class.laranja]="iconeLaranja">
      <mat-icon [class.laranja]="iconeLaranja">calendar_today</mat-icon>
    </span>

    <h2>Cadastradas em</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    role="button"
    aria-expanded="true"
    [attr.aria-controls]="'dropdown-tipo-obra'"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <mat-icon [class.girar-icon]="dropdown.isOpen">keyboard_arrow_down</mat-icon>
  </a>
</div>

<div
  class="collapse show check-total cadastradas-em"
  id="cadastrada-em"
  *ngIf="dropdown.isOpen && filtroCadastradaEm.length > 0"
>
  <ul>
    <li *ngFor="let cadastrada of filtroCadastradaEm" class="checkbox-item">
      <div class="form-radio form-check">
        <input
          type="radio"
          class="form-check-input custom-radio"
          [id]="'cadastrada-' + cadastrada.value"
          name="filtroCadastradaEm"
          [value]="cadastrada.value"
          [checked]="selecionado == cadastrada.value"
          (change)="onRadioChange(cadastrada.value)"
          [class.disabled]="disabled"
          [disabled]="disabled"
        />

        <label [for]="'cadastrada-' + cadastrada.value">
          {{ cadastrada.description }}
        </label>
      </div>
    </li>
  </ul>
</div>
